
	//TOOLS OPEN
	jQuery(function () {
		jQuery('.navbar-toggler').on('click', function(event) {
			event.preventDefault();
			jQuery(this).closest('.navbar-minimal').toggleClass('open');
		})
	});



	window.onorientationchange = function() {  	window.location.reload(); };

	function enable_tmpbackground(){
		jQuery('#imgsrc').addClass('sbackground');
		jQuery('.slogo').removeClass('none');
		jQuery('#sharecomb').addClass('none');

	}




	function disable_tmpbackground(){
		jQuery('#imgsrc').removeClass('sbackground');
		jQuery('.slogo').addClass('none');
		jQuery('#sharecomb').removeClass('none');
	}







	//VARIATION MIDDLE WITH VERTICAL SCROLL
	function middle(){

		function select_middle(currentdiv){

			var addpadding = parseInt(jQuery(window).width() / 2) - 75;

			//LA PARTE DEL PADDING FINAL NECESITA ALGUN CAMBIO - NO FUNCIONA BIEN
			jQuery('#' + currentdiv + '.scrolling-wrapper-flexbox').css({'padding-left' : addpadding + 'px', 'padding-right' : addpadding + 'px'});

			const div = jQuery('#' + currentdiv);
			div.on('scroll', function() {

				//PARA MENOR DILATACION AJUSTAR MEDIDAS
				jQuery('#' + currentdiv + ' .active').each(function(){

					//TAMAÑOS PERSONALIZADOS
					if(screen.width <= 768){	var centerLine = (jQuery(window).width() - jQuery('#imgsrc').width()) / 2;	}
				//	if(screen.width <= 600){	var centerLine = jQuery(window).width() / 2;		}

					var divStart = jQuery(this).offset().left;
					var divEnd = divStart + $(this).width();

					if(divStart < centerLine && divEnd > centerLine){
						jQuery('#' + jQuery(this).attr('id')).trigger('click');
					}
				});
			});
		}

		select_middle('items3');
		select_middle('items4');
		select_middle('items5');
		select_middle('items7');
		select_middle('items8');
		select_middle('items10');
		select_middle('items11');
		select_middle('items12');
		select_middle('items13');
	}







	//COPY TO CLIPBOARD
	function clipboard(){

		var text = jQuery('#toclipboard').val();

		if(text != ''){

			function selectElementText(element) {
				if (document.selection) {
					var range = document.body.createTextRange();
					range.moveToElementText(element);
					range.select();
				} else if (window.getSelection) {
					var range = document.createRange();
					range.selectNode(element);
					window.getSelection().removeAllRanges();
					window.getSelection().addRange(range);
				}
			}

			var element = document.createElement('DIV');
			element.textContent = text;
			document.body.appendChild(element);
			selectElementText(element);
			document.execCommand('copy');
			element.remove();

			jQuery('.options.copiar .mensaje').html('<br/>Enlace copiado');
		}

		if(text == ''){
			jQuery('.options.copiar .mensaje').html('<br/>Espere unos segundos...');

			setTimeout(function nwait(){
				clipboard();
			}, 5000);
		}
	}







	//FUNCIÓN PARA EL POPUP PARA COMPARTIR
	function compartir(){

		//GENERAMOS ID PARA COMPARTIR Y SHORT LINK
		var replicar = 'https://www.textura-interiors.com/brand/disena-tu-cama/index.html';

		replicar += '?a=' + jQuery('.square-item.selected').attr('identificador');						//TAMAÑO DE CAMA - ID
		replicar += '&b=' + jQuery('.subsquare.almohad.selected').attr('cat');					//TAMAÑO DE ALMOHADA - CAT
		replicar += '&c=' + jQuery('.variacion.color-item.bajera.selected').attr('identificador');			//SÁBANA BAJERA - ID
		replicar += '&d=' + jQuery('.subsquare.arriba.selected').attr('cat');				//PARTE DE ARRIBA CAT
		replicar += '&e=' + jQuery('.topper .variacion.color-item.selected').attr('identificador');		//PARTE DE ARRIBA ID
		replicar += '&f=' + jQuery('.itemline.almohadas .color-item.selected').attr('identificador');	//FUNA DE ALMOHADA - ID
		replicar += '&g=' + jQuery('.subsquare.cuadrante.selected').attr('cat');		//CUADRANTE CAT
		replicar += '&h=' + jQuery('#items7 .color-item.selected').attr('identificador');			//CUADRANTE ID

		if(typeof(jQuery('#items8 .color-item.selected').attr('identificador')) !== 'undefined'){
			replicar += '&i=' + jQuery('#items8 .color-item.selected').attr('identificador');			//CUADRANTE ID
		}

		var title = 'Comparte tu combinación ideal';
		var txt = 'Te mando mi cama. ¿Haces la tuya? ' + replicar;
		var url = '';

		if(navigator.canShare) {

			navigator.share({
				text: txt,
				title: title,
				url: url
			});
		}else{
			jQuery('.options.compartir .mensaje').html('\nSu navegador no soporta esta opción');
		}

	}







	//SCREEN SHOT
	function screenshot(){

		console.log('hola')
		enable_tmpbackground();

		var scrollY = jQuery(document).scrollTop();
		var scrollX = jQuery(document).scrollLeft();

		html2canvas(jQuery('#imgsrc')[0],{scrollY:-scrollY ,scrollX:-scrollX}).then(canvas => {

			//GENERAMOS IMAGEN VISIBLE PARA EL LAYER MODAL
			jQuery('#nimg').html(canvas);


			//GENERAMOS IMAGEN DATA APLICATION PARA BOTÓN "GUARDAR IMAGEN"
			var imgageData = canvas.toDataURL("image/png");
			var newData = imgageData.replace(/^data:image\/png/, "data:application/octet-stream");
			jQuery(".options.guardar").attr("download", "Textura Interiors.png").attr("href", newData);


			// jQuery('.variacion.color-item.selected').each(function(){
			// 	var capa = jQuery(this).attr('capa');
			// 	var base = 'https://cdn.shopify.com/s/files/1/0672/2804/1434/files/';
			// 	var img = jQuery(this).attr('img-data');
			// 	if(img.length != 0){
					
			// 		jQuery('.capa.' + capa).html('<img src="'+ base + img +'">');	
								
			// 	}
			// });
			

			//GUARDAMOS IMAGEN PARA BOTÓN "COPIAR ENLACE"
			var replicar = 'https://cdn.shopify.com/s/files/1/0672/2804/1434/files/';

			replicar += '?a=' + jQuery('.square-item.selected').attr('img-data');						//TAMAÑO DE CAMA - ID
			replicar += '&b=' + jQuery('.subsquare.almohad.selected').attr('img-data');					//TAMAÑO DE ALMOHADA - CAT
			replicar += '&c=' + jQuery('.variacion.color-item.bajera.selected').attr('img-data');			//SÁBANA BAJERA - ID
			replicar += '&d=' + jQuery('.subsquare.arriba.selected').attr('img-data');				//PARTE DE ARRIBA CAT
			replicar += '&e=' + jQuery('.topper .variacion.color-item.selected').attr('img-data');		//PARTE DE ARRIBA ID
			replicar += '&f=' + jQuery('.itemline.almohadas .color-item.selected').attr('img-data');	//FUNA DE ALMOHADA - ID
			replicar += '&g=' + jQuery('.subsquare.cuadrante.selected').attr('img-data');		//CUADRANTE CAT
			replicar += '&h=' + jQuery('#items7 .color-item.selected').attr('img-data');			//CUADRANTE ID

			if(typeof(jQuery('#items8 .color-item.selected').attr('identificador')) !== 'undefined'){
				replicar += '&i=' + jQuery('#items8 .color-item.selected').attr('identificador');			//CUADRANTE ID
			}

			jQuery(".options.copiar #toclipboard").val(replicar);
			jQuery(".options.copiar").attr('lnk', replicar);


		});

		disable_tmpbackground();
	}




	function nexsteps(units){

		for (var i = 1; i <= units; i++) {
			jQuery('.owl-nav .fa-angle-right').trigger('click');
		}

	}

	function laststeps(units){

		for (var i = 1; i <= units; i++) {
			jQuery('.owl-nav .fa-angle-left').trigger('click');
		}

	}
	function gotostep(units){

		jQuery('#variacion-3').trigger('click');
		jQuery('.owl-carousel.wblock').trigger('to.owl.carousel', units);

	}



	function generate_msg(txt){

		if(txt == ''){ return;	}
		jQuery('.message-items2').html(txt);

	}



	function generate_img(clases){

		if(screen.width <= 768){
		//if(400 < 768){

				var future = [];
				jQuery.each(clases, function(index, value){
					future.push( "'" + value + "'");
				});

				jQuery('#modalask').css('display','block');
				jQuery('#modalask .generate').val(future);

				jQuery('#modalask .optionspop').append('<input class="popaccept" type="button" value="SÍ, QUIERO PROBARLA" onclick="generate_cimg([' + future + '])"><input class="popcancel" type="button" value="NO, QUIERO MANTENERLA">');


		}else{

			jQuery.each(clases, function(index, value){
				jQuery(value).trigger('click');
			});

			nexsteps(7);
			jQuery('#modalask .popcancel').trigger('click');

			jQuery('html').animate({
					 scrollTop: 0
			}, 1000);
		}
	}





	function generate_cimg(clases){

		jQuery.each(clases, function(index, value){
			jQuery(value).trigger('click');
		});

		nexsteps(7);


		jQuery('#modalask .popcancel').trigger('click');
		jQuery('#row-volver').css('display','none');
		jQuery('#row-inspire').css('display','block');
		jQuery('#imgsrc').css('display','block');
		jQuery('#shop-module').css('display','block');

		jQuery('header').each(function(){
			if(jQuery(this).hasClass('d-md-none')) {
		 		jQuery('header').toggleClass('fixed-top');
		 	}
		 });

		$('html,body').animate({
			scrollTop: $('#img_personalizado').offset().top + 'px'
		});

		jQuery('body').css('overflow','hidden');
		changeImgWidth(70);
	}



	jQuery(document).ready(function(){


		//OPEN MODAL POP
		jQuery(document).on( "click", "#sharepop", function(event){
			event.preventDefault();

			jQuery('#modalpop').css('display','block');
			jQuery('#but_screenshot').trigger('click');
			jQuery(".options.guardar").trigger('click');
			jQuery(".nshare").css('display','none');

		});



		//CLOSE MODAL POP
		jQuery(document).on( "click", "#modalpop .close", function(event){
			event.preventDefault();

			jQuery('#modalpop').css('display','none');
		});




		//CLOSE MODAL POP ASK
		jQuery(document).on( "click", "#modalask .popcancel", function(event){
			event.preventDefault();

			jQuery('#modalask').css('display','none');
			jQuery('#modalask .optionspop').html('');
		});




		jQuery(".options.copiar").on('click', function (event) {
			event.preventDefault();

			clipboard();

		});




		jQuery(".options.compartir").on('click', function (event) {
			event.preventDefault();

			compartir();

		});



	});
